import React, {Component} from "react";

import "./BottomBarItem.css"

export class BottomBarItem extends Component {
    render() {
        return(
            <div className="bottomBarItem" onClick={this.handleClick}>
                <div className="bottomBarItem__cover">
                    <div className="bottomBarItem__lightEffect"/>
                    <div className="bottomBarItem__inner">
                        <div>
                            <img src={this.props.icon} width={24} height={24} alt="底部按鈕_圖示"/>
                        </div>
                        <div>
                            <span>{this.props.name}</span>
                        </div>
                    </div>    
                </div>    
                            
            </div>
        );
    }

    handleClick = (event) => {
        this.props.handleClick && this.props.handleClick(event, this.props.name);
    }
}